export function sddHelp(): string {
  return [
    '',
    '╔══════════════════════════════════════════════════════════════╗',
    '║          🚀 SDD — AI-Driven Spec Builder                    ║',
    '╚══════════════════════════════════════════════════════════════╝',
    '',
    '  ┌─ 🆕 Start ──────────────────────────────────────────────┐',
    '  │  /sdd new [title]    Start a new spec session            │',
    '  │  /sdd new --force    Start fresh (skip resume check)     │',
    '  │  /sdd resume         Resume a saved session              │',
    '  └──────────────────────────────────────────────────────────┘',
    '',
    '  ┌─ 🔄 Flow ───────────────────────────────────────────────┐',
    '  │  /sdd approve        Approve current phase               │',
    "  │  /sdd spec           Show current session's spec         │",
    '  │  /sdd plan           Show implementation plan            │',
    '  │  /sdd execute        Execute generated tasks             │',
    '  └────────────────────────────────────────────────────────┘',
    '',
    '  ┌─ ⏸ Goal Lifecycle ─────────────────────────────────────┐',
    '  │  /sdd goal            Show current goal + journal         │',
    '  │  /sdd goal set <text> Set autonomous mission             │',
    '  │  /sdd goal pause      Pause at end of current iteration  │',
    '  │  /sdd goal resume     Resume a paused goal               │',
    '  │  /sdd goal journal [N] Show recent journal entries       │',
    '  │  /sdd goal clear      Clear goal + stop eternal mode    │',
    '  └─────────────────────────────────────────────────────────┘',
    '',
    '  ┌─ 📡 Eternal Stage ──────────────────────────────────────┐',
    '  │  decide → execute → reflect → sleep | paused | stopped  │',
    '  │  Stage shown in real-time during /sdd goal mode         │',
    '  └─────────────────────────────────────────────────────────┘',
    '',
    '  ┌─ 🔧 Task Lifecycle ────────────────────────────────────┐',
    '  │  /sdd tasks          Show task list + progress bar      │',
    '  │  /sdd next           Show next executable task          │',
    '  │  /sdd done <N>       Complete a task                   │',
    '  │  /sdd skip <N>        Skip a task (back to pending)       │',
    '  │  /sdd fail <N>        Mark task as failed               │',
    '  │  /sdd review <N>      Send task to review              │',
    '  │  /sdd edit <N> <txt>  Edit task title or description   │',
    '  │  /sdd undo           Undo last completion              │',
    '  └─────────────────────────────────────────────────────────┘',
    '',
    '  ┌─ 📊 Session Info ──────────────────────────────────────┐',
    '  │  /sdd status         Full session status + tasks preview │',
    '  │  /sdd cancel         Cancel session                      │',
    '  └─────────────────────────────────────────────────────────┘',
    '',
    '  ┌─ ⚡ Parallel Run ──────────────────────────────────────┐',
    '  │  /sdd parallel [N]   Run tasks in parallel (N slots)     │',
    '  │  /sdd stop           Stop the active parallel run        │',
    '  │  /sdd retry-failed   Requeue all failed tasks            │',
    '  │  /sdd split <id> <A ; B>  Split a task into sub-tasks    │',
    '  └─────────────────────────────────────────────────────────┘',
    '',
    '  ┌─ 🧹 Lifecycle (after /sdd stop) ───────────────────────┐',
    '  │  /sdd clean          Remove run worktrees + branches     │',
    '  │  /sdd rollback       Revert the run\'s merged commits     │',
    '  │  /sdd destroy        Delete the whole SDD project         │',
    '  └─────────────────────────────────────────────────────────┘',
    '',
    '  ┌─ 📁 Spec History ─────────────────────────────────────┐',
    '  │  /sdd list           List saved specs                    │',
    '  │  /sdd show <id>      Show spec details                   │',
    '  │  /sdd templates      List available templates            │',
    '  │  /sdd from <tmpl>    Create from template                │',
    '  │  /sdd version <id>   Show version history                │',
    '  └─────────────────────────────────────────────────────────┘',
    '',
    '  ┌─ 💡 Quick Start ───────────────────────────────────────┐',
    '  │                                                         │',
    '  │  1. /sdd new Auth System                                │',
    '  │     → AI starts asking questions                        │',
    '  │                                                         │',
    '  │  2. Just type your answers naturally                    │',
    '  │     → AI continues the interview                        │',
    '  │                                                         │',
    '  │  3. AI generates spec (auto-detected)                   │',
    '  │     → /sdd approve                                    │',
    '  │                                                         │',
    '  │  3. AI generates implementation + tasks                 │',
    '  │     → /sdd approve                                    │',
    '  │                                                         │',
    '  │  4. AI executes tasks one by one                        │',
    '  │     → /sdd tasks (view progress)                       │',
    '  │     → /sdd done 1 (mark task complete)                  │',
    '  │                                                         │',
    '  └─────────────────────────────────────────────────────────┘',
    '',
    '  Tip: tasks are shown with progress bar after each AI turn.',
    '',
  ].join('\n');
}
